import React, { useRef } from 'react';

import { APTooltipProvider, useTooltip } from 'components/Tooltip';

import './tooltip-button.scss';

const TooltipButton = (props) => {

  const { mode, tooltipProps, ...buttonProps } = props || {};
  const { message, tooltipDelay, floatingProps } = tooltipProps || {};

  if (mode === 'tooltip') {
    return (
      <APTooltipProvider
        tooltipDelay={tooltipDelay}
        floatingProps={floatingProps}
      >
        <UnderlyingButton
          {...buttonProps}
          message={message}
        />
      </APTooltipProvider>
    );
  }

  return (
    <button
      type="button"
      className="button"
      {...buttonProps}
    >
      {buttonProps.children}
    </button>
  );
};

const UnderlyingButton = ({ message, ...rest }) => {
  const ref = useRef();
  const { disabled, ...buttonProps } = rest;
  const { setCurrentTitle, setAnchor } = useTooltip();

  const onMouseEnter = () => {
    setCurrentTitle(message);
    setAnchor(ref.current);
  };

  const onMouseMove = () => {
    setCurrentTitle(message);
    setAnchor(ref.current);
  };

  const onMouseLeave = () => {
    setCurrentTitle(null);
    setAnchor(null);
  };

  if (disabled) {
    return (
      <button
        ref={ref}
        {...buttonProps}
        type="button"
        className="button disabled-button"
        aria-disabled={disabled}
        onClick={(e) => e.preventDefault()}
        onPointerEnter={onMouseEnter}
        onPointerMove={onMouseMove}
        onPointerLeave={onMouseLeave}
      >
        {rest.children}
      </button>
    );
  }

  return (
    <button
      ref={ref}
      type="button"
      className="button"
      {...rest}
      onMouseEnter={onMouseEnter}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      {rest.children}
    </button>
  );
};

export default TooltipButton;
